import axios from 'axios'

const axiosInstance = axios.create({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export const deviceLogin = {
  generateDeviceToken: async function (pinCode) {
    try {
      let res = await axiosInstance.request({
        method: 'POST',
        url: `https://ipanel.barsoft.hu/api/v1/auth/device/generate`,
        data: { pinCode }
      })
      return res.data
    } catch (e) {
      return { success: false, code: 500 }
    }
  },
  refreshDeviceToken: async function (apiUrl, token) {
    try {
      let res = await axios.request({
        method: 'POST',
        url: `${apiUrl}/api/v1/auth/refreshJWTToken`,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      return res.data
    } catch (e) {
      return { success: false, code: 500 }
    }
  },
  checkDevice: async function (apiUrl, token, clientUID) {
    try {
      let res = await axios.request({
        method: 'POST',
        url: `${apiUrl}/api/v1/auth/checkDevice`,
        data: { clientUID },
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      return res.data
    } catch (e) {
      return { success: false, code: 500 }
    }
  },
  remoteDeviceLogin: async function (code) {
    try {
      let res = await axios.request({
        method: 'POST',
        url: `https://ipanel.barsoft.hu/api/v1/auth/device/remoteLogin`,
        data: { code },
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return res.data
    } catch (e) {
      return { success: false, code: 500 }
    }
  }
}
